(function() {
    'use strict';

    angular
        .module('sigmasfApp')
        .controller('LeadOfferDeleteController',LeadOfferDeleteController);

    LeadOfferDeleteController.$inject = ['$uibModalInstance', 'entity', 'LeadOffer'];

    function LeadOfferDeleteController($uibModalInstance, entity, LeadOffer) {
        var vm = this;
        vm.leadOffer = entity;
        vm.clear = function() {
            $uibModalInstance.dismiss('cancel');
        };
        vm.confirmDelete = function (id) {
            LeadOffer.delete({id: id},
                function () {
                    $uibModalInstance.close(true);
                });
        };
    }
})();
